import { WorkflowVersion } from "@/components/Workflows/types";
import { useUser } from "@/context/user-context";
import { ListPromptVersion } from "@/types";
import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { TooltipContent } from "@radix-ui/react-tooltip";
import { ExternalLinkIcon, ScaleIcon } from "lucide-react";
import TooltipAction from "./TooltipAction";
import { Label } from "./types";

const VersionTooltipContent = ({
  isWorkflow,
  id,
  dynamicReleaseLabelsRegistry,
  allLabels,
  promptId,
  handleABTestButtonClick,
  version,
  versionNumber,
  number,
}: {
  isWorkflow: boolean;
  id: number;
  dynamicReleaseLabelsRegistry: { [version: number]: Label[] };
  allLabels: any[];
  promptId: string | undefined;
  handleABTestButtonClick: (promptId: number, promptVersionId: number) => void;
  version: WorkflowVersion | ListPromptVersion;

  versionNumber: string | undefined;
  number: number;
}) => {
  const activeWorkspaceId = useUser()?.activeWorkspaceId!;
  return (
    <TooltipContent
      className="flex -translate-x-1/2 flex-col flex-wrap gap-1 rounded-md text-xs text-black"
      side="right"
      sideOffset={5}
      align="center"
    >
      {!isWorkflow &&
        ((!dynamicReleaseLabelsRegistry?.[id] && allLabels.length > 0) ||
          dynamicReleaseLabelsRegistry?.[id]?.length < allLabels.length) && (
          <TooltipAction
            icon={<ScaleIcon className="inline h-3 w-3" />}
            label="Start A/B Test"
            onClick={() => handleABTestButtonClick(Number(promptId), id)}
          />
        )}
      {"report_id" in version && version.report_id && (
        <TooltipAction
          icon={<ExternalLinkIcon className="inline h-3 w-3" />}
          label="Open Evaluation"
          to={`/workspace/${activeWorkspaceId}/evaluate/reports/${version.report_id}`}
          openInNewTab={true}
        />
      )}
      {!isWorkflow && Number(versionNumber) !== number && (
        <TooltipAction
          icon={<MagnifyingGlassIcon className="inline h-3 w-3" />}
          label="View Diff"
          to={`/workspace/${activeWorkspaceId}/prompt/${promptId}/version/${versionNumber}/diff/${number}`}
        />
      )}
    </TooltipContent>
  );
};

export default VersionTooltipContent;
